if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        // Unsubscribe from box builder state changes
        if (this._boxUnsub) {
          this._boxUnsub();
          this._boxUnsub = null;
        }

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

      const productUrl = opener.getAttribute('data-product-url');
      const quickViewUrl = productUrl + (productUrl.includes('?') ? '&' : '?') + 'view=quick-view';
      fetch(quickViewUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.productElement.setAttribute('data-update-url', 'false');
            this.productElement.dataset.isQuickView = true;
            this.setInnerHTML(this.modalContent, this.productElement.parentElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            if (this.dataset.directCart === 'true') {
              this.applyDirectCartMode();
            } else {
              this.applyBoxBuilderMode();
            }
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            const spinnerEl = opener.querySelector('.loading__spinner');
            if (spinnerEl) spinnerEl.classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      /**
       * When the box builder is active, adapt the modal's add-to-cart form
       * to use the same box controls ("Legg til i boks" / [−] qty [+]) as
       * the product grid cards.
       */
      applyBoxBuilderMode() {
        if (!window.boxBuilder || !window.boxBuilder.store) return;

        const store = window.boxBuilder.store;

        // Remove the "box only" message (shown on standalone product pages)
        // and unhide the product-form so we can convert it to a box button.
        const boxOnlyMsg = this.modalContent.querySelector('.product-form--box-only');
        if (boxOnlyMsg) boxOnlyMsg.remove();
        const hiddenProductForm = this.modalContent.querySelector('product-form[style*="display:none"], product-form[style*="display: none"]');
        if (hiddenProductForm) hiddenProductForm.style.display = '';

        const form = this.modalContent.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        const variantInput = form.querySelector('.product-variant-id, [name="id"]');
        if (!variantInput) return;

        const variantId = variantInput.value;

        // Find the button container (.product-form__buttons) and wrap it
        // with data-box-variant-id so BoxBuilderFormInterceptor can manage it.
        const btnContainer = form.querySelector('.product-form__buttons') || form;
        const wrapper = document.createElement('div');
        wrapper.className = 'box-qty-wrapper';
        wrapper.setAttribute('data-box-variant-id', variantId);

        // Move the product-form into the wrapper
        const productForm = form.closest('product-form');
        if (productForm) {
          productForm.parentNode.insertBefore(wrapper, productForm);
          wrapper.appendChild(productForm);
        }

        // Change button text from "Legg til i handlekurv" to "Legg til i boks"
        const submitBtn = form.querySelector('.product-form__submit, .quick-add__submit, .add-to-cart__submit');
        if (submitBtn) {
          const textSpan = submitBtn.querySelector('span > span') || submitBtn.querySelector('span');
          if (textSpan && textSpan.textContent.trim() !== '') {
            textSpan.textContent = 'Legg til i boks';
          }
        }

        // Hide dynamic checkout buttons (Buy it now, etc.) in box mode
        const dynamicCheckout = this.modalContent.querySelector('.shopify-payment-button');
        if (dynamicCheckout) dynamicCheckout.style.display = 'none';

        // Trigger BoxBuilderFormInterceptor to sync this new container
        // (renders [−] qty [+] if product already has items in the box)
        if (window.boxBuilder.interceptor && window.boxBuilder.interceptor._syncAllCards) {
          window.boxBuilder.interceptor._syncAllCards();
        }

        // Keep the modal in sync when box state changes (e.g. from sticky bar)
        this._boxUnsub = store.onStateChange(() => {
          if (window.boxBuilder.interceptor && window.boxBuilder.interceptor._syncAllCards) {
            window.boxBuilder.interceptor._syncAllCards();
          }
        });
      }

      /**
       * Direct-cart popup mode: keep the normal add-to-cart form (instead of
       * converting it to a "Legg til i boks" control), allow it past the
       * Råvareboks-only cart gate via data-allow-direct-purchase, and label the
       * button "Legg i handlekurv".
       */
      applyDirectCartMode() {
        // Remove the "box only" message and unhide the (normally hidden) form.
        const boxOnlyMsg = this.modalContent.querySelector('.product-form--box-only');
        if (boxOnlyMsg) boxOnlyMsg.remove();
        const hiddenProductForm = this.modalContent.querySelector('product-form[style*="display:none"], product-form[style*="display: none"]');
        if (hiddenProductForm) hiddenProductForm.style.display = '';

        // Curated boxes: hide the per-variant portion count in the popup.
        this.modalContent.querySelectorAll('.product__porsjoner').forEach((el) => el.remove());

        // Let product-form.js bypass the "only Råvareboks may be added" gate.
        const productForm = this.modalContent.querySelector('product-form');
        if (productForm) productForm.setAttribute('data-allow-direct-purchase', 'true');

        const form = this.modalContent.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) return;

        const submitBtn = form.querySelector('.product-form__submit, .quick-add__submit, .add-to-cart__submit');
        if (submitBtn && !submitBtn.disabled) {
          const textSpan = submitBtn.querySelector('span > span') || submitBtn.querySelector('span');
          if (textSpan) textSpan.textContent = 'Legg i handlekurv';
        }
      }

      removeDOMElements() {
        // Unwrap <a> tags inside .product__title so the title is not a link in the modal
        this.productElement.querySelectorAll('.product__title a').forEach((anchor) => {
          const parent = anchor.parentNode;
          while (anchor.firstChild) {
            parent.insertBefore(anchor.firstChild, anchor);
          }
          parent.removeChild(anchor);
        });

        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        // Hide "Se fullstendige detaljer" link visually but keep for SEO
        this.productElement.querySelectorAll('.product__view-details').forEach((link) => {
          link.classList.add('visually-hidden');
        });

        // Remove complementary products grid (e.g. Fresh/frozen items)
        const complementary = this.productElement.querySelectorAll('product-recommendations, .complementary-products');
        complementary.forEach((el) => el.remove());

      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// Card quick-view: intercept clicks on product card image/title links
// when the product_card_click_action setting is set to 'quick_view'
(function initCardQuickView() {
  function bindQuickViewTriggers() {
    document.querySelectorAll('[data-quickview-trigger]').forEach((link) => {
      if (link.dataset.quickviewBound) return;
      link.dataset.quickviewBound = 'true';

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const card = link.closest('product-info');
        if (!card) return;

        const productId = card.dataset.productId;
        if (!productId) return;

        const modal = document.querySelector(`#QuickAdd-${productId}`);
        if (!modal) return;

        // Create a lightweight opener proxy compatible with QuickAddModal.show()
        const productUrl = link.dataset.productUrl || link.getAttribute('href');
        const opener = document.createElement('button');
        opener.setAttribute('data-product-url', productUrl);
        opener.style.display = 'none';
        document.body.appendChild(opener);

        modal.show(opener);

        // Clean up the temporary opener after the modal is done loading
        const cleanup = () => {
          if (opener.parentNode) opener.parentNode.removeChild(opener);
        };
        // Use a MutationObserver to detect when modal content is loaded
        const observer = new MutationObserver(() => {
          if (modal.querySelector('[id^="QuickAddInfo-"]').innerHTML.trim() !== '') {
            modal.openedBy = link;
            cleanup();
            observer.disconnect();
          }
        });
        observer.observe(modal.querySelector('[id^="QuickAddInfo-"]'), { childList: true });
        // Fallback cleanup after 10 seconds
        setTimeout(() => { cleanup(); observer.disconnect(); }, 10000);
      });
    });
  }

  // Bind on initial load and after Shopify section events (for AJAX-loaded content)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindQuickViewTriggers);
  } else {
    bindQuickViewTriggers();
  }
  document.addEventListener('shopify:section:load', bindQuickViewTriggers);
})();
